import { render } from "./NewPageLayout.vue?vue&type=template&id=d6b2dddc"
import script from "./NewPageLayout.vue?vue&type=script&lang=js"
export * from "./NewPageLayout.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__